import {useSelector} from "react-redux";
import {Button} from "@material-ui/core";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import Screen from '../screen';
import './index.scss';
import ChuzeatFooter from "../footer/ChuzeatFooter";
import { RootState } from "../../store";
import { MenuFromApi } from "../../models/menu";

interface MenuChooserProps {
  goToMenu: (menu: MenuFromApi) => void;
  menus: MenuFromApi[];
}

const MenuChooser: React.FC<MenuChooserProps> = ({
    goToMenu,
    menus,
}) => {
    return (<Screen className="screen menu-cohose-screeen">
        <div className="content_container with_footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p className="user_questions">
                            {LocalizerHelper.localized('menu_chooser_header')}
                        </p>
                    </div>
                </div>
                <div className="container-buttons-action">
                    <div>
                        {
                            menus.map((item) => (<div className="row" key={item.docId}>
                                <div className="col-md-12">
                                    <Button className="accent-button full-width button" onClick={() => goToMenu(item)}>
                                        {LocalizerHelper.localized(item, ['name'])}
                                    </Button>
                                </div>
                            </div>))
                        }
                    </div>
                </div>   
            </div>
            
        </div>
        <ChuzeatFooter/>
    </Screen>);
};

export default MenuChooser;
